import { Component } from '@angular/core';

import { FieldsetModule } from 'primeng/fieldset';

import dangerFieldset from 'src/assets/themes/biifor/components/fieldset';

// Composants
import { PageBaseComponent } from 'src/app/@shared/components/abstract/page-base.component';
import { AddressFormComponent } from 'src/app/@shared/components/addresses/address-form/address-form.component';
import { ClientFormComponent } from '../../components/clients/client-form/client-form.component';
import { ClientMfaFormComponent } from '../../components/clients/client-mfa-form/client-mfa-form.component';
import { MfaInfoComponent } from 'src/app/@shared/components/mfa/mfa-info/mfa-info.component';
import { CreateClientFormComponent } from '../../components/clients/create-client-form/create-client-form.component';
import { DangerZoneFormComponent } from '../../components/clients/danger-zone-form/danger-zone-form.component';

// Modèles
import { Client } from 'src/app/@shared/models/client/client.model';

@Component({
    selector: 'app-client',
    imports: [
        FieldsetModule,
        AddressFormComponent,
        ClientFormComponent,
        ClientMfaFormComponent,
        MfaInfoComponent,
        CreateClientFormComponent,
        DangerZoneFormComponent
    ],
    templateUrl: './client.component.html',
    styleUrls: ['./client.component.scss']
})
export class ClientComponent extends PageBaseComponent {

    /*----------------------------------------------------------------------------------------
     * Gestion de la vue
     ----------------------------------------------------------------------------------------*/

    public dangerFieldset = dangerFieldset;

    /*----------------------------------------------------------------------------------------
     * Données
     ----------------------------------------------------------------------------------------*/

    private _client: Client | null = null;
    public get client(): Client | null {
        return this._client;
    }
    public set client(client: Client | null) {
        this._client = client;
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes publiques
     ----------------------------------------------------------------------------------------*/

    public onClientCreated(client: Client) {
        this.userService.loadClients();
        this.appService.selectClient(client);
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes protégées
     ----------------------------------------------------------------------------------------*/

    protected override buildBreadcrumbs(): void {
        if (this.client) {
            this.appService.breadcrumbItems = [
                {
                    label: 'Paramètres',
                    routerLink: [this.appService.clientUrl('/settings')]
                },
                {
                    label: 'Société : Données générales'
                }
            ]
        } else {
            this.appService.breadcrumbItems = [];
        }
    }

    protected override subscribeToObservables(): void {
        // `/client/new` est un écran de création : il ne doit pas basculer sur la
        // fiche du dossier courant si l'utilisateur en a un d'ouvert (#173)
        if (this.route.snapshot.data['creation']) {
            this.client = null;
            return;
        }
        // Sélection d'un client dans l'application
        this.subscriptions.add(
            this.appService.clientSelected$.subscribe(
                client => {
                    this.client = client;
                    if (!!client) {
                        this._setTitle(client);
                    }
                }
            )
        );
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes privées
     ----------------------------------------------------------------------------------------*/

    private _setTitle(client: Client) {
        let title = `Société - ${client?.commercialName}`;
        this.setTitle(title);
    }

}
